import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

// 새로운 저장소 객체 생성
export function newPersistAtom(key: string = 'sessionStorage') {
  // 스토리지에 저장하는 기능
  const { persistAtom } = recoilPersist({
    key: key,
    storage: sessionStorage || localStorage || undefined, // localStorage 또는 sessionStorage
  });
  return persistAtom;
}

//confirm
export const confirmState = atom<{ text: string; cancelFunc?: () => void; submitFunc: () => void }>({
  key: 'confirmState',
  default: {
    text: '',
    cancelFunc: undefined,
    submitFunc: () => {},
  },
});

// 로더 상태
export const loaderState = atom({
  key: 'loaderState',
  default: {
    show: false,
  },
});
